import React, { useContext } from 'react'
import SpecialistContext from './SpecialistContext'
import { screenSize } from '../../Common/Common'
import MobileSpecialist from './Mobile/MobileSpecialist'
import ComputerSpecialist from './Computer/ComputerSpecialist'
import TabletSpecialist from './Tablet/TabletSpecialist'
import { Typography } from 'antd'
import { Color } from '../../Common/Color'
import dayjs from 'dayjs'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { t } from 'i18next'

export default function SpecialistPage () {
  const {
    defineCalendar, allSpecialists, specialists, allMonthAvailabilities,
    setReason, reasons, setSpecialist, monthAvailabilities, date, getMonthAvailabilities,
    setDay, day, saveSlot, specialist, reason
  } = useContext(SpecialistContext)

  const selectSpecialist = (value) => {
    if (value === undefined) {
      defineCalendar(specialists, allMonthAvailabilities)
    } else {
      const selectedSpecialist = allSpecialists.find(e => e.id === value)
      defineCalendar([selectedSpecialist], allMonthAvailabilities)
    }
  }

  const selectReason = (value) => {
    const selectedReason = reasons.find(e => e.id === value)
    setReason(selectedReason)
    setSpecialist(undefined)
  }

  const dateCellRender = (value) => {
    if (monthAvailabilities && monthAvailabilities.length > 0 && date && value.$M === date.month()) {
      return <div className='custom' style={{ color: monthAvailabilities[value.$D - 1].color, '--background-color': monthAvailabilities[value.$D - 1].color, height: '49px', paddingTop: '10px', fontSize: '16px' }}>
        {value.$D}
      </div>
    } else if (value.$M === date.month()) {
      return <div style={{ color: 'red', height: '49px', paddingTop: '10px', fontSize: '16px' }}>{value.$D}</div>
    } else {
      return <div style={{ height: '49px', paddingTop: '10px', fontSize: '16px' }}>{value.$D}</div>
    }
  }

  const dateInSelectionnableRange = (date) => {
    return date >= dayjs() && date <= dayjs().add(60, 'day')
  }

  const dateManipulation = (date, month) => {
    let newDate
    if (month > 11) {
      newDate = date.clone().add(1, 'month').startOf('month')
    } else if (month < 0) {
      newDate = date.clone().subtract(1, 'month').startOf('month')
    } else {
      newDate = date.clone().month(month).startOf('month')
    }
    return newDate < dayjs() && month === dayjs().month() ? dayjs() : newDate
  }

  const headerRender = ({ value, onChange }) => {
    const title = dayjs(value.$d).format('MMMM YYYY')
    const onClick = (newMonth) => {
      const newDate = dateManipulation(value, newMonth)
      if (dateInSelectionnableRange(newDate)) {
        getMonthAvailabilities(newDate)
        onChange(newDate)
      }
    }
    const canNavigatePrev = dateInSelectionnableRange(dateManipulation(value, value.clone().subtract(1, 'month').month()))
    const canNavigateNext = dateInSelectionnableRange(dateManipulation(value, value.clone().add(1, 'month').month()))
    const style = { fontSize: '2em', margin: '0.5em 0.7em 0 0.7em', cursor: 'pointer', '--hover-color': Color.red }
    const disabled = { cursor: 'not-allowed', color: 'grey' }

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: Color.green, borderRadius: '16px 16px 0 0', color: Color.white }}>
        <div className={canNavigatePrev ? 'hoverable' : ''} onClick={() => { onClick(value.month() - 1) }} style={canNavigatePrev ? style : { ...style, ...disabled }}><LeftOutlined /></div>
        <Typography.Title level={4} style={{ color: Color.white }}>{title}</Typography.Title>
        <div className={canNavigateNext ? 'hoverable' : ''} onClick={() => { onClick(value.month() + 1) }} style={canNavigateNext ? style : { ...style, ...disabled }}><RightOutlined /></div>
      </div>
    )
  }

  const onSelect = (selectedDay) => {
    if (selectedDay.month() !== day.month()) {
      getMonthAvailabilities(selectedDay.startOf('month'))
    }
    setDay(selectedDay)
  }

  const onClick = (slot, calendarId, reasonId) => {
    saveSlot(slot, calendarId, reasonId)
  }

  const displaySlots = (slots) => {
    if (slots && slots.length > 0) {
      return slots.map((slot) => (
        <div className='hoverable'
          onClick={() => onClick(slot, specialist?.id, reason.id)}
          key={slot.time.format('DD/MM/YYYY HH:mm')}
          style={{
            textAlign: 'center',
            width: '75px',
            display: 'inline-block',
            fontSize: '16px',
            border: '1px solid black',
            borderRadius: '2em',
            padding: '0.4em 1em',
            margin: '1em 1em',
            '--hover-color': Color.red,
            '--hover-border-color': Color.red,
            cursor: 'pointer'
          }}
        >
          {slot.time.format('HH:mm')}
        </div>
      ))
    } else {
      return t('Public.Specialist.noSlots')
    }
  }

  const slotPage = {
    Mobile: MobileSpecialist,
    Computer: ComputerSpecialist,
    Tablet: TabletSpecialist
  }

  const ResponsivePage = slotPage[screenSize()]

  return (
    <ResponsivePage selectSpecialist={selectSpecialist} selectReason={selectReason}
      dateCellRender={dateCellRender} headerRender={headerRender} onSelect={onSelect}
      displaySlots={displaySlots}
    />
  )
}
